/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'

import { AOSRJsonType, SecondaryActJsonType } from '../../Types/dataJSON'
import { getRelativeSizePt, paragraphFontSize } from '../molecules/basis'
import { EditableSpan } from '../molecules/EditableSpan'
import { ITextTemplateActSection } from '../template.type'

type TemplateTextType = {
  section: ITextTemplateActSection
  actItems: AOSRJsonType | SecondaryActJsonType
  selectedField?: any
  onChange: (e: string, key: string, id?: string) => void
  onToggle: (item: ITextTemplateActSection & { value: string }) => void
  fontSize?: string
}

export const TemplateText = ({
  section,
  actItems,
  selectedField,
  fontSize = paragraphFontSize,
  onChange,
  onToggle,
}: TemplateTextType) => {
  const textParts = section.text?.split('**')

  return (
    <div
      css={css`
        line-height: ${getRelativeSizePt(16)};
        margin-top: ${getRelativeSizePt(8)};
        font-weight: ${section.styles?.fontWeight};
        font-family: 'PT-Astra-Serif', serif;
        font-size: ${fontSize};
        width: ${section.styles?.width};
        max-width: ${getRelativeSizePt(545)};
        align-self: ${section.styles?.align === 'right'
          ? 'flex-end'
          : 'flex-start'};
        font-style: ${section.styles?.fontStyle ?? 'italic'};
        text-align: ${section.styles?.textAlign === 'right'
          ? 'end'
          : section.styles?.textAlign === 'left'
          ? 'start'
          : section.styles?.textAlign};
        white-space: pre-wrap;
      `}
    >
      {textParts &&
        textParts.map((part, index) => {
          return index % 2 ? (
            part.includes('!') ? (
              <>{actItems && actItems[part.replace('!', '')]?.value} </>
            ) : (
              <EditableSpan
                key={part}
                contentEditable
                id={part}
                role="textbox"
                selectedId={selectedField}
                suppressContentEditableWarning={true}
                onTextChange={value => onChange(value ?? '', `${part}.value`)}
                onToggle={value =>
                  onToggle({
                    key: part,
                    value: value ?? '',
                    title: '',
                    text: section.text,
                    type: section.type,
                  })
                }
              >
                {actItems && actItems[part]?.value}
              </EditableSpan>
            )
          ) : (
            part
          )
        })}
    </div>
  )
}
